/**
 * Created by Ning Jiang on 2022-07-26.
 */

import {Serial} from "../../Serial";
import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {SerialGameMode} from "../../server/SerialGameMode";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {ReelPositionController} from "../../reels/ReelPositionController";
import {gsap} from "gsap";
import {XSplitSymbol} from "../../symbol/XSplitSymbol";
import {SerialSound} from "../../sound/SerialSound";

export class JumpingScatterController extends ReelStopPresentationController {

    public jumpingScatter:XSplitSymbol | null;
    public symId:number; // 0-2
    private _jumpTimeline:TimelineLite | null;

    constructor() {
        super("JumpingScatterController");
    }

    public init():void {
        for(let i = 2; i < 5; i++) {
            let sym = Serial.getSymbol(4, i);
            if(sym.symbolName === "S2") {
                this.jumpingScatter = <XSplitSymbol>sym;
                this.symId = i - 2;
                break;
            }
        }

        if(this.jumpingScatter == null) {
            debugger;
            throw new Error(`S2 parsing error when entering super fs!`);
        }
    }

    public finish():void {
        this.jumpingScatter = null;
        this.symId = -1;
    }

    public startSpin():void {
        if(this.jumpingScatter) {
            this.jumpingScatter.startSpin();
        }
    }

    public async start():Promise<void> {
        if(Serial.model.data.mode === SerialGameMode.FREESPIN_SUPER) {
            // start to move
            if(!this.jumpingScatter) {
                debugger;
                throw new Error(`JumpingScatterController.start with no jumpingScatter!`);
            }
            const jumpingData = Serial.model.parsedGameData.jumpingS2;
            if(jumpingData.originalReelRow != jumpingData.newRowPos) {
                Serial.reels[4].moveOverlay(jumpingData.originalReelRow - 2, jumpingData.newRowPos - 2);
                this.symId = jumpingData.newRowPos - 2;

                const newPosition = ReelPositionController.REEL_AREAS[4].y + (jumpingData.newRowPos - 1) * ReelPositionController.DEFAULT_SYMBOL_HEIGHT
                // this.jumpingScatter.y = newPosition;
                let bounced = false;
                const tl = gsap.timeline();
                tl.add([
                    gsap.to(this.jumpingScatter, {
                        y : newPosition,
                        duration : 0.5,
                        ease : "back.inOut(3)",
                        onUpdate : () => {
                            if(bounced) {
                                return;
                            }

                            if((jumpingData.newRowPos > jumpingData.originalReelRow && this.jumpingScatter!.y >= newPosition) ||
                                (jumpingData.originalReelRow > jumpingData.newRowPos && this.jumpingScatter!.y <= newPosition)) {
                                bounced = true;
                                SerialSound.soundPlayer.playTrack({name : SerialSound.X_SPLIT_MOVE_END});
                            }
                        }
                    }),
                    () => {SerialSound.soundPlayer.playTrack({name : SerialSound.X_SPLIT_MOVE});}
                ]);
                tl.add(() => {this.jumpingScatter?.stopSpin()});
                this._jumpTimeline = tl;
            } else {
                this.jumpingScatter?.stopSpin();
            }
        }
        return super.start();
    }

    protected onReelStopped(data:IReelStateEventData):Promise<any> {
        if(Serial.model.data.mode === SerialGameMode.FREESPIN_SUPER && data.reelId === 4) {
            if(this._jumpTimeline && this._jumpTimeline.isActive()) {
                this._jumpTimeline.progress(1);
            }
        }
        this._jumpTimeline = null;
        return super.onReelStopped(data);
    }
}